"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = exports.LayoutDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var theme_2 = require("@shapeable/theme");
var lodash_1 = require("lodash");
var component_size_1 = __importDefault(require("@rehooks/component-size"));
var use_full_screen_state_1 = require("../../hooks/use-full-screen-state");
var useRef = React.useRef;
exports.LayoutDefaultProps = {
  pad: false,
  unbounded: false,
  transparent: true,
  throttleBy: 200,
  center: false,
  bottom: false,
  hideOverflow: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    box-sizing: border-box;\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    box-sizing: border-box;\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), function (props) {
    return props.hideOverflow && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      overflow: hidden;\n    "], ["\n      overflow: hidden;\n    "])));
  }, function (props) {
    return props.pad && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme_2.theme.UNIT(4));
  }, function (props) {
    return props.backgroundColor && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme_2.theme.COLOR(props.backgroundColor));
  }),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.pad && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme_2.theme.UNIT(6));
  }),
  desktop: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.pad && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme_2.theme.UNIT(6));
  }),
  last: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    @media screen and (min-width: 1235px) {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  "], ["\n    @media screen and (min-width: 1235px) {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  "])))
});
var BackgroundStyles = (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  ", " \n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  ", " \n"])), function (props) {
  return props.isFullScreen && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    max-width: none;\n  "], ["\n    max-width: none;\n  "])));
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    position: relative;\n    margin: 0 auto;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    z-index: 10;\n    box-sizing: border-box;\n\n    ", "\n  "], ["\n    position: relative;\n    margin: 0 auto;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    z-index: 10;\n    box-sizing: border-box;\n\n    ", "\n  "])), function (props) {
    return props.bottom && (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n    "], ["\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", "\n\n  "], ["\n    ", "\n\n  "])), function (props) {
    return props.center && (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n    "], ["\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n    "])));
  })
});
var OverlayStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: rgba(0, 0, 0, 0.2);\n    z-index: 5;\n  "], ["\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: rgba(0, 0, 0, 0.2);\n    z-index: 5;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Background: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), BackgroundStyles),
  Overlay: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), OverlayStyles)
};
/**
 * Finds the first entry in the aspectRatio entry which meets the min-width requirement for the current width provided
 *
 */
var findAspectRatio = function (aspectRatio, currentWidth, fallback) {
  if (fallback === void 0) {
    fallback = 16 / 9;
  }
  if ((0, lodash_1.isNumber)(aspectRatio)) {
    return aspectRatio;
  }
  var asArray = (0, lodash_1.map)(aspectRatio, function (ratio, key) {
    return {
      key: key,
      ratio: ratio
    };
  });
  var minRatio = (0, lodash_1.minBy)(asArray, function (_a) {
    var key = _a.key,
      ratio = _a.ratio;
    var width = theme_1.minWidth[key] || 0;
    var difference = currentWidth - width;
    // Note if the difference is negative then the current width is below the required width, so we return Infinity as negative numbers are even smaller for minBy 
    return difference >= 0 ? difference : Infinity;
  });
  return minRatio ? minRatio.ratio : fallback;
};
var Layout = function (props) {
  var isFullScreen = (0, use_full_screen_state_1.useFullScreenState)().isFullScreen;
  var container = useRef();
  var size = (0, component_size_1.default)(container);
  var width = size.width;
  var aspectRatio = props.aspectRatio;
  var style = {};
  if (aspectRatio) {
    var ratio = findAspectRatio(aspectRatio, width);
    style.minHeight = "".concat(Math.round(width / ratio), "px");
  }
  var children = props.children,
    className = props.className,
    unbounded = props.unbounded,
    center = props.center,
    overlay = props.overlay,
    background = props.background,
    backgroundColor = props.backgroundColor,
    pad = props.pad,
    transparent = props.transparent,
    bottom = props.bottom,
    corrected = props.corrected;
  return React.createElement(My.Container, {
    pad: pad,
    ref: container,
    transparent: transparent,
    backgroundColor: backgroundColor,
    className: className,
    style: style
  }, React.createElement(My.Background, {
    isFullScreen: isFullScreen
  }, background), overlay && React.createElement(My.Overlay, null), React.createElement(My.Body, {
    center: center,
    bottom: bottom,
    corrected: corrected,
    isFullScreen: isFullScreen,
    unbounded: unbounded
  }, children));
};
exports.Layout = Layout;
exports.Layout.defaultProps = exports.LayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;